import { queryOptions } from '@tanstack/react-query';
import { walletBalanceQueryFunction } from '@/modules/Dashboard/queries/walletBalance/walletBalanceQueryFunction.ts';

export const walletBalanceQueryOptions = queryOptions({
  queryKey: ['wallet-balance'],
  queryFn: walletBalanceQueryFunction,
  staleTime: 30 * 1000,
  gcTime: 30 * 1000,
  select: (data) => ({
    totalBalance: data.total_balance,
    lastDeposit: data.last_deposit,
  }),
});
